import { useEffect } from "react"
import Grid       from '@mui/material/Grid'
import Box        from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import Paper      from '@mui/material/Paper'
import '../../App.css'
import '../../style.css'

function StartTyping({ onSpace }) {

    useEffect(() => {
        const handleKeyDown = (e) => {
            // 押しっぱなしで連打扱いになるのを防ぐ
            if (e.repeat) return

            // スペースキー判定
            if (e.code === "Space" || e.key === " ") {
                e.preventDefault()
                onSpace?.()
            }
        }

        // passive:false を指定して preventDefault を効かせる
        window.addEventListener("keydown", handleKeyDown, { passive: false })

        return () => {
        window.removeEventListener("keydown", handleKeyDown)
        }
    }, [onSpace])

    return (
        <Box sx={{ m : 1 , p : 4}}>
            {/* 画面 */}
            <Paper sx={{
                m: 1, p: 1,
                bgcolor      : '#f5f5dc',
                borderRadius : "1px",
                height       : "250px",
                width        : '250px',
                position     : 'absolute',
                top          : '20px',
                left         : '40px',
            }}>
                <br/><br/><br/><br/><br/>
                <Grid container spacing={0}>
                <Grid item xs={12} align="center">
                    <Typography
                    sx={{
                        fontFamily : 'DotGothic16',
                        fontSize   : "13px",
                        color      : '#000000',
                    }}
                    >
                    タイピング中はキーボードを使います。
                    </Typography>
                </Grid>
                <Grid item xs={12} align="center">
                    <Typography
                    className="blinking-text"
                    sx={{
                        fontFamily : 'DotGothic16',
                        fontSize   : "15px",        
                        color      : '#DD0000',
                        fontWeight : 'bold',
                    }}
                    >
                    スペースを押すとスタートします。
                    </Typography>
                </Grid>
                </Grid>
            </Paper>
            <Grid container spacing={2}>
                <Grid item xs={12} align="center"></Grid>
            </Grid>
        </Box>
    )
}

export default StartTyping
